/** @jsx jsx */
import { jsx } from 'theme-ui';
import { StripeProvider as WrappedStripeProvider, Elements, injectStripe, } from 'react-stripe-elements';
import { clientConfig } from '../util/clientConfig';
import { useState, useEffect, useContext, createContext } from 'react';
var HookContext = createContext([null, null]);
var HookProvider = injectStripe(function (_a) {
    var stripe = _a.stripe, elements = _a.elements, children = _a.children;
    return (jsx(HookContext.Provider, { value: [stripe, elements] }, children));
});
export var useStripe = function () { return useContext(HookContext); };
export var StripeProvider = function (_a) {
    var children = _a.children, accountId = _a.accountId;
    var _b = useState(null), stripe = _b[0], setStripe = _b[1];
    useEffect(function () {
        var initializeStripe = function () {
            setStripe(window.Stripe(clientConfig.stripeClientSecret, {
                stripeAccount: accountId,
            }));
        };
        if (window.Stripe) {
            initializeStripe();
        }
        else {
            document.querySelector('#stripe-js').addEventListener('load', function () {
                initializeStripe();
            });
        }
    }, [accountId]);
    return (jsx(WrappedStripeProvider, { stripe: stripe },
        jsx(Elements, null,
            jsx(HookProvider, null, children))));
};
//# sourceMappingURL=StripeContext.js.map